import { render, staticRenderFns } from "./SimExam.vue?vue&type=template&id=48cf0870&scoped=true&"
import script from "./SimExam.vue?vue&type=script&lang=js&"
export * from "./SimExam.vue?vue&type=script&lang=js&"
import style0 from "./SimExam.vue?vue&type=style&index=0&id=48cf0870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf0870",
  null
  
)

export default component.exports